var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full text-xs"},[_vm._t("default"),(!_vm.noMargin)?_c('div',{staticClass:"details-area"},[(_vm.isError)?[_vm._v(_vm._s(_vm.errorMessage))]:_vm._e()],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }